module.exports = __webpack_public_path__ + "img/SEJ_Eventos_qr validado.0b3b6f8f.svg";